import React from 'react';
import PropTypes from 'prop-types';
import Report from '../../../ReportByReferral/ReportByReferral';
import DragScroll from '../../../../utils/DragScroll';

export class StatisticsByReferralTable extends Report {
    constructor(props, context) {
        super(props, context);
        this.tableWrapperClass = {
            'table-responsive': true,
            'table-responsive_compact-report': true,
            ...(props.tableWrapperClass || {})
        };

        this.state = {
            data: props.data,
            headerName: props.headerName,
            loading: props.loading,
            order: props.order,
            sort: props.sort,
            metrics: props.metrics,
            keysMetric: props.keysMetric,
            isSorting: true,
            isTableFirst: true
        };
    }

    onClickDocument(e) {
        let referrerRow = e.target.closest("tr.referrer-row");
        if (null !== referrerRow) {
            referrerRow.classList.toggle('show-info');

            let detailIcon =  referrerRow.querySelector('.detail-icon');
            if (referrerRow.classList.contains('show-info')) {
                detailIcon.classList.remove('glyphicon-plus-sign');
                detailIcon.classList.add('glyphicon-minus-sign');
            } else {
                detailIcon.classList.remove('glyphicon-minus-sign');
                detailIcon.classList.add('glyphicon-plus-sign');
            }

            let parentId = referrerRow.getAttribute('data-current-parent-id');
            let childElements = document.querySelectorAll('[data-parent-id="'+ parentId +'"]');
            if (childElements) {
                childElements.forEach(element => {
                    element.classList.toggle('hidden');
                });
            }
        }
    }

    componentDidMount() {
        this.setBodyData();
        new DragScroll({ className: 'table-responsive' });
        document.body.addEventListener('click', this.onClickDocument.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        const isChangeData = nextProps.data !== this.state.data;

        this.setState({
            data: nextProps.data,
            headerName: nextProps.headerName,
            loading: nextProps.loading,
            order: nextProps.order,
            sort: nextProps.sort,
            metrics: nextProps.metrics
        }, () => {
            isChangeData && this.setBodyData();
        });
    }
}

StatisticsByReferralTable.propTypes = {};

StatisticsByReferralTable.defaultProps = {};

StatisticsByReferralTable.contextTypes = {
    t: PropTypes.object
};

export default StatisticsByReferralTable;
